//未开通
export const wallet_status_not_opened = -3;

//冻结
export const wallet_status_feoze = -2;

//注销
export const wallet_status_unsubscribe = -1;

//锁定
export const wallet_status_lock = 0;

//正常
export const wallet_status_normal = 1;

//余额不足
export const wallet_status_insufficient = 2;
